import { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { reload } from "firebase/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { auth, functions } from "../firebase";
import { useLanguage } from "../i18n/LanguageProvider";

const confirmAccountEmailChangeSecure = httpsCallable(
  functions,
  "confirmAccountEmailChangeSecure"
);

function copy(language) {
  const isDe = language === "de";
  return {
    loading: isDe ? "E-Mail-Adresse wird bestätigt..." : "Confirming email address...",
    successTitle: isDe ? "E-Mail-Adresse bestätigt" : "Email address confirmed",
    successText: isDe
      ? "Deine neue E-Mail-Adresse wurde erfolgreich für VaultQuest übernommen."
      : "Your new email address has been applied to VaultQuest successfully.",
    errorTitle: isDe ? "Bestätigung nicht möglich" : "Confirmation failed",
    errorText: isDe
      ? "Der Link ist ungültig oder abgelaufen. Bitte fordere die E-Mail-Änderung erneut an."
      : "The link is invalid or has expired. Please request the email change again.",
    login: isDe ? "Zur Anmeldung" : "Go to login",
    app: isDe ? "Zur App" : "Go to app",
  };
}

function EmailChangeConfirmPage() {
  const { language } = useLanguage();
  const text = copy(language);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const token = searchParams.get("token") || "";

  useEffect(() => {
    let cancelled = false;

    const confirm = async () => {
      if (!token) {
        setStatus("error");
        return;
      }

      try {
        await confirmAccountEmailChangeSecure({ token });
        if (auth.currentUser) {
          await reload(auth.currentUser).catch(() => null);
        }
        if (!cancelled) setStatus("success");
      } catch (error) {
        console.error("email change confirmation failed:", error?.code || error?.message || "unknown");
        if (!cancelled) setStatus("error");
      }
    };

    confirm();

    return () => {
      cancelled = true;
    };
  }, [token]);

  const isLoading = status === "loading";
  const isSuccess = status === "success";

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#000",
        padding: "calc(24px + var(--vq-safe-area-top)) calc(20px + var(--vq-safe-area-right)) calc(24px + var(--vq-safe-area-bottom)) calc(20px + var(--vq-safe-area-left))",
        boxSizing: "border-box",
        color: "white",
        fontFamily: "'Cooper Hewitt', system-ui, -apple-system, Arial, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 390,
          borderRadius: 28,
          padding: "28px 22px 22px",
          background: "linear-gradient(180deg, rgba(255,255,255,0.11), rgba(255,255,255,0.045))",
          border: "2px solid rgba(255,255,255,0.18)",
          boxShadow: "0 24px 70px rgba(0,0,0,0.38)",
          textAlign: "center",
          boxSizing: "border-box",
        }}
      >
        <img
          src="/vaultquest-logo.png"
          alt="VaultQuest"
          draggable="false"
          style={{
            width: 106,
            height: 106,
            objectFit: "contain",
            marginBottom: 18,
            filter: "drop-shadow(0 18px 38px rgba(168,85,247,0.36))",
          }}
        />
        <h1
          style={{
            margin: "0 0 12px",
            fontSize: 25,
            fontWeight: 1000,
            lineHeight: 1.1,
            textTransform: "uppercase",
          }}
        >
          {isLoading ? text.loading : isSuccess ? text.successTitle : text.errorTitle}
        </h1>
        {!isLoading && (
          <p
            style={{
              margin: "0 0 22px",
              color: "rgba(255,255,255,0.78)",
              fontSize: 15,
              lineHeight: 1.55,
              fontWeight: 800,
            }}
          >
            {isSuccess ? text.successText : text.errorText}
          </p>
        )}
        {!isLoading && (
          <button
            type="button"
            onClick={() => navigate(auth.currentUser ? "/" : "/login", { replace: true })}
            style={{
              width: "100%",
              minHeight: 56,
              borderRadius: 999,
              border: "2px solid rgba(255,255,255,0.30)",
              background: "linear-gradient(90deg, #ff007f 0%, #7a2bff 100%)",
              color: "white",
              fontWeight: 1000,
              fontSize: 15,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            {auth.currentUser ? text.app : text.login}
          </button>
        )}
      </div>
    </div>
  );
}

export default EmailChangeConfirmPage;
